/**
 * True when a rejection came from an `AbortController`, not from a real failure.
 *
 * An abort is identified by its `name`, not its prototype: `fetch` rejects with a `DOMException`,
 * which inherits from `Error` in browsers but not in every realm, so an `instanceof Error` guard
 * would silently treat a cancelled request as a real failure. Under jsdom it is not an `Error`, so
 * that form passes in a browser and fails in tests.
 */
export function isAbortError(error: unknown): boolean {
  return typeof error === 'object' && error !== null && 'name' in error && (error as { name?: unknown }).name === 'AbortError'
}
